<template>
  <div class="app-container">
    <el-row>
      <el-col :span="24">
        <!-- 面包屑导航区域-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
          <el-breadcrumb-item>Development</el-breadcrumb-item>
          <el-breadcrumb-item>Project Time Line Graphical</el-breadcrumb-item>
          <el-breadcrumb-item>Project Id: {{this.formInline.projectId}}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-card style="width:100%;">
      <div style="width:100%;height:600px" ref="chart"></div>
    </el-card>
  </div>
</template>

<script>
import * as echarts from 'echarts/lib/echarts'

export default {
  name: 'ProTimeLineGrap',
  data () {
    return {
      list: [],
      a: '',
      b: ''
    }
  },
  created () {
    this.formInline = this.$route.query
  },
  mounted () {
    this.initCharts()
  },
  methods: {
    async initCharts () {
      const { data: res } = await this.$http.get('/timeline/getTimeline', { params: { value: this.formInline.id } })
      const listDe = res.decoTimelines
      console.log(listDe)
      const listV = []
      const listV1 = []
      const listV2 = []
      const listV3 = []
      const listV4 = []
      const listV5 = []
      const listV6 = []
      for (let i = 0; i < listDe.length; i++) {
        if (listDe[i].first_estimate) {
          listV1.push(listDe[i].first_estimate)
          listV2.push(listDe[i].first_estimate)
        } else {
          listV1.push('')
          listV2.push('')
        }
        listV.push(listDe[i].item_name)

        if (listDe[i].revised_estimate) {
          listV3.push(listDe[i].revised_estimate)
          listV4.push(listDe[i].revised_estimate)
        } else {
          listV3.push('')
          listV4.push('')
        }

        if (listDe[i].completed) {
          listV5.push(listDe[i].completed)
          listV6.push(listDe[i].completed)
        } else {
          listV5.push('')
          listV6.push('')
        }
      }
      listV1.shift()
      listV3.shift()
      listV5.shift()
      const myChart = echarts.init(this.$refs.chart)
      // myChart.clear()
      // const a = moment('2021/01/1 07:23:24', 'YYYY-MM-DD').format('YYYY-MM-DD')
      // const b = moment('2021/01/31 07:23:24', 'YYYY-MM-DD').format('YYYY-MM-DD')
      // console.log(a)
      // console.log(b)
      myChart.setOption(
        {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {},
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'time'
            // axisLabel: {
            //   formatter: function (params) {
            //     echarts.format.formatTime('yyyy-MM-dd', params)
            //   }
            // }
          },
          yAxis: {
            // inverse: true,
            type: 'category',
            // data: ['Proof Submission', 'Proof Approval for Sampling', '1st Sampling Submission', 'Comments - 1st Sampling', '2nd Sampling Submission', 'Comments - 2st Sampling', '3nd Sampling Submission', 'Final Decoration Approval']
            data: listV
          },
          series: [
            {
              name: 'SUPPLIER FIRST ESTIMATE',
              type: 'bar',
              stack: 'SUPPLIER FIRST ESTIMATE',
              label: {
                show: true
              },
              emphasis: {
                focus: 'series'
              },
              data: listV1
            },
            {
              name: 'SUPPLIER FIRST ESTIMATE',
              type: 'bar',
              stack: 'SUPPLIER FIRST ESTIMATE',
              itemStyle: {
                color: '#fff',
                borderColor: '#fff'
              },
              data: listV2
            },
            {
              name: 'REVISED ESTIMATE',
              type: 'bar',
              stack: 'REVISED ESTIMATE',
              label: {
                show: true
              },
              emphasis: {
                focus: 'series'
              },
              data: listV3
            },
            {
              name: 'REVISED ESTIMATE',
              type: 'bar',
              stack: 'REVISED ESTIMATE',
              itemStyle: {
                color: '#fff',
                borderColor: '#fff'
              },
              data: listV4
            },
            {
              name: 'COMPLETED',
              type: 'bar',
              stack: 'COMPLETED',
              label: {
                show: true
              },
              emphasis: {
                focus: 'series'
              },
              data: listV5
            },
            {
              name: 'COMPLETED',
              type: 'bar',
              stack: 'COMPLETED',
              itemStyle: {
                color: '#fff',
                borderColor: '#fff'
              },
              data: listV6
            }
            // {
            //   name: 'PRO2',
            //   type: 'line',
            //   // stack: 'total',
            //   label: {
            //     show: true
            //   },
            //   emphasis: {
            //     focus: 'series'
            //   },
            //   data: ['2020-11-1', '2020-11-2', '2020-11-2', '2020-11-3', '2020-11-4', '2020-11-5']
            // }
          ]
        }
        , true)
    },
    async getList (value) {
      const { data: res } = await this.$http.get('/timeline/getTimeline', { params: { value: this.formInline.id } })
      // console.log(res)
      this.list = res
      console.log(1111)
      console.log(this.list)
    }
  }
}
</script>

<style scoped>

</style>
